import { useState } from "react";
import PropTypes from "prop-types";
import { Button, Modal } from "@/config/antd";
import { useNavigate } from "react-router-dom";
import Avatar from "@/components/common/Avatar";
import AttendeeCard from "@/pages/event_management/single_campaign/components/attendees_tabs/Attendee_Card";

const SpeakersTab = ({ speakers }) => {
  const [isViewAllOpen, setIsViewAllOpen] = useState(false);
  const navigate = useNavigate();

  // Function to handle navigation to user profile
  const navigateToProfile = (speakerId) => {
    navigate(`/dashboard/users/${speakerId}`);
  };

  // Pass through profile image; AttendeeCard / Avatar handles the global dummy fallback
  const getProfileImage = (speaker) => speaker.profileImage || null;

  // Open view all modal
  const handleViewAll = () => {
    setIsViewAllOpen(true);
  };

  if (!speakers?.length) {
    return (
      <div className="text-center text-gray-500 py-4">
        No speakers found for this town hall
      </div>
    );
  }

  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold text-darkGrey">
          Speakers ({speakers.length})
        </h3>
        <Button
          type="link"
          className="text-primary font-bold"
          onClick={handleViewAll}>
          VIEW ALL
        </Button>
      </div>

      <div className="space-y-4">
        {speakers.map((speaker) => (
          <AttendeeCard
            key={speaker._id}
            attendee={{
              id: speaker._id,
              name: speaker.fullname,
              avatar: getProfileImage(speaker),
              confirmed: true,
              username: speaker.username || speaker.fullname,
            }}
            onClick={() => navigateToProfile(speaker._id)}
          />
        ))}
      </div>

      {/* View All Speakers Modal */}
      <Modal
        open={isViewAllOpen}
        onCancel={() => setIsViewAllOpen(false)}
        footer={null}
        centered
        width={800}
        title="All Speakers">
        <div className="max-h-[500px] overflow-y-auto p-4">
          {!speakers || speakers.length === 0 ? (
            <div className="text-center py-4">
              No speakers found for this town hall
            </div>
          ) : (
            <div className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-6 gap-4">
              {speakers.map((speaker, index) => (
                <div
                  key={speaker?._id || index}
                  className="flex flex-col items-center">
                  <div
                    className="cursor-pointer"
                    onClick={() => navigateToProfile(speaker._id)}>
                    <Avatar
                      src={getProfileImage(speaker)}
                      alt={speaker.fullname || "Speaker"}
                      size={64}
                      className="cursor-pointer"
                    />
                  </div>
                  <p className="mt-2 text-small font-medium text-center text-gray-800">
                    {speaker.fullname?.split(" ")[0] ||
                      speaker.username ||
                      "Unknown"}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

SpeakersTab.propTypes = {
  speakers: PropTypes.array,
};

export default SpeakersTab;
